import type { Colors, DefaultTheme } from 'styled-components';
import { lightColors, mapLightTheme } from './LightTheme';

const colors: Colors = {
  ...lightColors,
  primary: {
    lighten: '#08dfde',
    default: '#06aead',
    dim: 'rgba(6,174,173,0.4)',
    mute: 'rgba(6,174,173,0.1)',
  },
  gray: {
    '100': '#1d1d28',
    '000': '#e6e6e7',
    '010': '#f2f2f3',
    main: '#ffffff',
    '020': '#fafafa',
    '030': '#ebebeb',
    '040': '#dbdbdd',
    '050': '#d2d2d4',
    '060': '#c8c8ca',
    '070': '#bbbbbe',
    '080': '#9b9b9f',
    '090': '#696970',
  },
  green: {
    lighten: '#57a55e',
    default: '#45844b',
    dim: 'rgba(69,132,75,0.4)',
    mute: 'rgba(69,132,75,0.1)',
  },
  red: {
    lighten: '#a6423a',
    default: '#80332d',
    dim: 'rgba(128,51,45,0.4)',
    mute: 'rgba(128,51,45,0.1)',
  },
  yellow: {
    lighten: '#af7d2a',
    default: '#866020',
    dim: 'rgba(134,96,32,0.4)',
    mute: 'rgba(134,96,32,0.1)',
  },
  orange: {
    lighten: '#af7d2a',
    default: '#866020',
    dim: 'rgba(134,96,32,0.4)',
    mute: 'rgba(134,96,32,0.1)',
  },
  blue: {
    lighten: '#5fa2e7',
    default: '#3388E0',
    dim: 'rgba(51,136,224,0.4)',
    mute: 'rgba(51,136,224,0.1)',
  },
  purple: {
    lighten: '#9f73d7',
    default: '#844BCC',
  },
  white: {
    default: '#ffffff',
    dim: 'rgba(255,255,255,0.4)',
    mute: 'rgba(255,255,255,0.1)',
  },
  black: {
    default: '#000000',
    dim: 'rgba(0,0,0,0.4)',
    mute: 'rgba(0,0,0,0.1)',
  },
};

export const LightCopperTheme: DefaultTheme = mapLightTheme(colors, {
  name: 'LightCu',

  colorTextDefaultButton: '#000000',
  colorTextDefaultButtonHover: '#000000',
  colorTextDefaultButtonFocus: '#000000',
  colorTextDefaultButtonActive: '#000000',
  colorTextDefaultButtonDisabled: 'rgba(0,0,0,0.5)',

  colorTextPositiveButton: '#000000',
  colorTextPositiveButtonHover: '#000000',
  colorTextPositiveButtonFocus: '#000000',
  colorTextPositiveButtonActive: '#000000',
  colorTextPositiveButtonDisabled: 'rgba(0,0,0,0.5)',

  colorTextPrimaryButton: '#000000',
  colorTextPrimaryButtonHover: '#000000',
  colorTextPrimaryButtonFocus: '#000000',
  colorTextPrimaryButtonActive: '#000000',
  colorTextPrimaryButtonDisabled: 'rgba(0,0,0,0.5)',

  colorTextMutedButton: '#000000',
  colorTextMutedButtonHover: '#000000',
  colorTextMutedButtonFocus: '#000000',
  colorTextMutedButtonActive: '#000000',
  colorTextMutedButtonDisabled: 'rgba(0,0,0,0.5)',
});
